/*
 * RICO #29968 — Final Sale property safety net.
 *
 * Ensures every line item whose product is tagged "finalsale" carries the
 * "Final sale" line item property. Replaces the per-section once-per-page-load
 * scripts that were creating duplicate line items when adds happened after the
 * initial render (e.g. Wiser quick-add, Klevu, second add from the PDP).
 *
 * Strategy:
 *   1. Upfront injection at every add-to-cart form happens in snippets/buy-buttons.liquid
 *      and snippets/product-card.liquid via a hidden properties[Final sale] input.
 *   2. This script is the catch-all: on every cart:change or cart:refresh, it inspects
 *      the cart and attaches the property to any finalsale-tagged line item that is
 *      missing it. Two line items that converge on the same (variant + properties)
 *      will then merge on the next /cart/change.js call.
 */
(function () {
  var FINAL_SALE_PROP = 'Final sale';
  var finalSaleText = (window.__finalSaleText || '').toString().trim();
  if (!finalSaleText) return;

  var tagCache = Object.create(null);
  var inflight = Object.create(null);
  var processed = new Set(); // memoKey -> already evaluated for this session

  function isFinalsale(tags) {
    if (!Array.isArray(tags)) return false;
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).replace(/[\s-]/g, '').toLowerCase() === 'finalsale') return true;
    }
    return false;
  }

  function getProductTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (tagCache[handle] !== undefined) return Promise.resolve(tagCache[handle]);
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var tags = (p && p.tags) ? p.tags.slice() : [];
        tagCache[handle] = tags;
        return tags;
      })
      .catch(function () { return []; })
      .then(function (tags) { delete inflight[handle]; return tags; });
    return inflight[handle];
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function attachProperty(item) {
    var props = Object.assign({}, item.properties || {});
    props[FINAL_SALE_PROP] = finalSaleText;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, properties: props })
    });
  }

  var running = false;
  var pending = false;

  function syncOnce() {
    return getCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var changed = false;
      var work = items.reduce(function (chain, item) {
        return chain.then(function () {
          if (!item || !item.key) return;
          var memoKey = item.key + '|' + (item.handle || '');
          var hasProp = item.properties && item.properties[FINAL_SALE_PROP] === finalSaleText;
          if (hasProp) { processed.add(memoKey); return; }
          if (processed.has(memoKey)) return;
          return getProductTags(item.handle).then(function (tags) {
            if (!isFinalsale(tags)) { processed.add(memoKey); return; }
            return attachProperty(item).then(function () {
              changed = true;
              processed.add(memoKey);
            }).catch(function () { /* swallow; next event retries */ });
          });
        });
      }, Promise.resolve());
      return work.then(function () {
        if (changed) {
          // Tell cart-aware widgets the cart updated so the drawer/page rerenders the merged state.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      });
    }).catch(function () { /* swallow */ });
  }

  function sync() {
    if (running) { pending = true; return; }
    running = true;
    syncOnce().then(function () {
      running = false;
      if (pending) { pending = false; sync(); }
    });
  }

  document.addEventListener('cart:change', sync);
  document.addEventListener('cart:refresh', sync);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
